import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  CircularProgress,
  Typography,
  keyframes,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";
import CountertopsIcon from "@mui/icons-material/Countertops";

import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { GetTimeline } from "../../../lib/api/CoordinatorAPI";
import {
  Schedule,
  CheckCircle,
  Autorenew,
  Pending,
  AccessTime,
  InfoOutlined,
} from "@mui/icons-material";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const CompletedToken = ({
  data,
  CompletedTokens,
  isLoading,
  selectedServiceId,
}) => {
  const [isDelayedLoading, setIsDelayedLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [tokenValue, setTokenValue] = useState("");
  const [depPrefix, setDepPrefix] = useState("");
  const [timelineLoading, setTimelineLoading] = useState(false);

  useEffect(() => {
    const delayTimer = setTimeout(() => {
      setIsDelayedLoading(false);
    }, 1000);
    return () => clearTimeout(delayTimer);
  }, [isLoading]);

  const handleTokenClick = async (token) => {
    const { TokenValue: tokenValue, DepPrefix: depPrefix } = token;
    setTokenValue(tokenValue);
    setDepPrefix(depPrefix);
    setShowPopup(true);
    setTimelineLoading(true);

    try {
      const timelineData = await GetTimeline(depPrefix, tokenValue);
      setPopupData(timelineData?.data?.data);
    } catch (error) {
      setPopupData(null);
    } finally {
      setTimelineLoading(false);
    }
  };

  if (isLoading || isDelayedLoading) {
    return (
      <Paper
        className="flex"
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          borderRadius: "16px",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <CircularProgress
            size={60}
            thickness={4}
            sx={{
              animation: `${spin} 1s linear infinite`,
              color: "primary.main",
            }}
          />
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "text.primary",
              fontSize: "1.5rem",
            }}
          >
            Loading Tokens
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              fontSize: "1rem",
            }}
          >
            Please wait while we fetch the data...
          </Typography>
        </Box>
      </Paper>
    );
  }

  const filteredTokens = data?.data?.tokensOnCompleted.filter((token) => {
    if (!selectedServiceId) return true;
    const serviceId = Number(selectedServiceId);
    return token.ServiceID === serviceId;
  });

  const evenTokens = filteredTokens?.filter((item, index) => index % 2 === 0);
  const oddTokens = filteredTokens?.filter((item, index) => index % 2 === 1);

  if (isLoading) {
    return (
      <Paper
        className="flex"
        sx={{
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          height: 200,
        }}
      >
        <CircularProgress />
        <Typography variant="body1" sx={{ marginTop: 2 }}>
          Loading tokens...
        </Typography>
      </Paper>
    );
  }

  return (
    <>
      <Paper className="flex" sx={{ width: "100%" }}>
        <TableContainer sx={{ maxHeight: 440 }} className="flex">
          <Table>
            <TableBody>
              {evenTokens?.map((evenTokens, index) => {
                return (
                  <TableRow key={index + 1}>
                    <TableCell
                      style={{
                        textAlign: "center",
                        fontSize: "25px",
                        fontWeight: "bold",
                        verticalAlign: "top",
                        borderRightWidth: "1px",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          backgroundColor: "rgba(37, 82, 235, 0.05)",
                          transform: "scale(1.02)",
                        },
                      }}
                      onClick={() => handleTokenClick(evenTokens)}
                    >
                      <div>
                        {`${evenTokens?.DepPrefix || Cookies.get("DepPrefix")}${
                          evenTokens.TokenValue
                        }`}
                        {Cookies.get("isServiceEnable") === "true" ? (
                          <div
                            style={{
                              fontSize: "15px",
                              fontWeight: "normal",
                            }}
                          >
                            {evenTokens?.ServiceName || ""}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Table>
            <TableBody>
              {oddTokens?.map((oddTokens, index) => {
                return (
                  <TableRow key={index + 1}>
                    <TableCell
                      style={{
                        textAlign: "center",
                        fontSize: "25px",
                        fontWeight: "bold",
                        verticalAlign: "top",
                        borderLeftWidth: "1px",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          backgroundColor: "rgba(37, 82, 235, 0.05)",
                          transform: "scale(1.02)",
                        },
                      }}
                      onClick={() => handleTokenClick(oddTokens)}
                    >
                      <div>
                        {`${oddTokens?.DepPrefix || Cookies.get("DepPrefix")}${
                          oddTokens.TokenValue
                        }`}
                        {Cookies.get("isServiceEnable") === "true" ? (
                          <div
                            style={{
                              fontSize: "15px",
                              fontWeight: "normal",
                            }}
                          >
                            {oddTokens?.ServiceName || ""}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Dialog
        open={showPopup}
        onClose={() => setShowPopup(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            background: "linear-gradient(145deg, #f5f7fa 0%, #e4e8ed 100%)",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            border: "2px solid #2552EB",
          },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: "#2552EB",
            color: "white",
            display: "flex",
            alignItems: "center",
            gap: 2,
            py: 2,
            background: "linear-gradient(135deg, #2552EB 0%, #3A6AFF 100%)",
            borderTopLeftRadius: "14px",
            borderTopRightRadius: "14px",
          }}
        >
          <Schedule fontSize="large" sx={{ color: "white" }} />
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ textShadow: "0 2px 4px rgba(0,0,0,0.2)" }}
          >
            Token Timeline - {depPrefix}
            {tokenValue}
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ py: 3 }}>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              borderRadius: "12px",
              background: "rgba(255,255,255,0.9)",
              border: "1px solid rgba(37, 82, 235, 0.2)",
              marginTop: "16px",
            }}
          >
            {timelineLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: 200,
                }}
              >
                <CircularProgress size={60} />
              </Box>
            ) : popupData?.length > 0 ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                {popupData.map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 3,
                      p: 2,
                      borderRadius: "8px",
                      bgcolor:
                        index % 2 === 0
                          ? "rgba(37, 82, 235, 0.05)"
                          : "transparent",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 12px rgba(37, 82, 235, 0.1)",
                      },
                    }}
                  >
                    {item.TokenStatus === "completed" ? (
                      <CheckCircle
                        sx={{
                          fontSize: 32,
                          color: "#4CAF50",
                          filter:
                            "drop-shadow(0 2px 4px rgba(76, 175, 80, 0.3))",
                        }}
                      />
                    ) : item.TokenStatus === "Generated" ? (
                      <Autorenew
                        sx={{
                          fontSize: 32,
                          color: "#2196F3",
                          filter:
                            "drop-shadow(0 2px 4px rgba(33, 150, 243, 0.3))",
                        }}
                      />
                    ) : (
                      <Pending
                        sx={{
                          fontSize: 32,
                          color: "#FF9800",
                          filter:
                            "drop-shadow(0 2px 4px rgba(255, 152, 0, 0.3))",
                        }}
                      />
                    )}

                    <Box sx={{ flexGrow: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: 1,
                        }}
                      >
                        <Typography
                          variant="h6"
                          fontWeight="bold"
                          sx={{
                            color:
                              item.TokenStatus === "completed"
                                ? "#4CAF50"
                                : item.TokenStatus === "Generated"
                                ? "#2196F3"
                                : "#FF9800",
                          }}
                        >
                          {index === 0
                            ? "Generated"
                            : item.TokenStatus === "Pending"
                            ? "Pending"
                            : item.TokenStatus.charAt(0).toUpperCase() +
                              item.TokenStatus.slice(1)}
                        </Typography>

                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <AccessTime fontSize="small" />
                          <Typography
                            variant="body1"
                            sx={{ color: "text.secondary" }}
                          >
                            {item.TokenTime}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Counter and Department Row */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: 1,
                          mt: 1,
                        }}
                      >
                        {/* Department/From-To Section */}
                        <Box sx={{ display: "flex", gap: 2 }}>
                          {item.DepFromName &&
                          item.DepToName &&
                          item.DepFromName === item.DepToName ? (
                            <Typography
                              variant="body2"
                              sx={{ color: "text.secondary" }}
                            >
                              <strong>Department:</strong> {item.DepFromName}
                            </Typography>
                          ) : (
                            <>
                              {item.DepFromName && (
                                <Typography
                                  variant="body2"
                                  sx={{ color: "text.secondary" }}
                                >
                                  <strong>From:</strong> {item.DepFromName}
                                </Typography>
                              )}
                              {item.DepToName &&
                                item.DepFromName !== item.DepToName && (
                                  <>
                                    <ArrowForward
                                      fontSize="small"
                                      sx={{ color: "text.secondary" }}
                                    />
                                    <Typography
                                      variant="body2"
                                      sx={{ color: "text.secondary" }}
                                    >
                                      <strong>To:</strong> {item.DepToName}
                                    </Typography>
                                  </>
                                )}
                            </>
                          )}
                        </Box>

                        {/* Counter Section */}
                        {item.CounterName && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <CountertopsIcon fontSize="small" />
                            <Typography
                              variant="body2"
                              sx={{ color: "text.secondary" }}
                            >
                              <strong>Counter:</strong> {item.CounterName}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Box>

                    {/* Timeline Connector */}
                    {index < popupData?.length - 1 && (
                      <Box
                        sx={{
                          height: "40px",
                          width: "2px",
                          bgcolor: "rgba(37, 82, 235, 0.3)",
                          ml: 4,
                          position: "relative",
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            top: "100%",
                            left: "-4px",
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            bgcolor: "#2552EB",
                            boxShadow: "0 2px 4px rgba(37, 82, 235, 0.3)",
                          },
                        }}
                      />
                    )}
                  </Box>
                ))}
              </Box>
            ) : (
              <Box
                sx={{
                  textAlign: "center",
                  py: 4,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <InfoOutlined
                  sx={{ fontSize: 48, color: "#2552EB", opacity: 0.7 }}
                />
                <Typography variant="body1" sx={{ color: "text.secondary" }}>
                  No timeline data available
                </Typography>
              </Box>
            )}
          </Paper>
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            py: 2,
            borderTop: "1px solid rgba(37, 82, 235, 0.1)",
            background: "rgba(37, 82, 235, 0.03)",
          }}
        >
          <Button
            variant="contained"
            onClick={() => setShowPopup(false)}
            sx={{
              borderRadius: "8px",
              px: 4,
              py: 1.5,
              textTransform: "none",
              fontWeight: "bold",
              background: "linear-gradient(135deg, #2552EB 0%, #3A6AFF 100%)",
              boxShadow: "0 4px 8px rgba(37, 82, 235, 0.3)",
              "&:hover": {
                background: "linear-gradient(135deg, #1E45C7 0%, #305AD9 100%)",
                boxShadow: "0 6px 12px rgba(37, 82, 235, 0.4)",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CompletedToken;
